var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"kuaishou-text-ad",on:{"click":_vm.handleClick}},[_c('img',{staticClass:"icon",attrs:{"src":require("@/assets/volume-notice.png")}}),_c('div',{staticClass:"content"},[_vm._v(_vm._s(_vm.text))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }